'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: 100%;\n'], ['\n  height: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _AppHeader = require('./components/AppHeader');

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _AppSidebar = require('./components/AppSidebar');

var _AppSidebar2 = _interopRequireDefault(_AppSidebar);

var _StyledSidebar = require('./StyledSidebar');

var _StyledSidebar2 = _interopRequireDefault(_StyledSidebar);

var _StyledMain = require('./StyledMain');

var _StyledMain2 = _interopRequireDefault(_StyledMain);

var _StyledContent = require('./StyledContent');

var _StyledContent2 = _interopRequireDefault(_StyledContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppLayoutOuterDiv = _styledComponents2.default.div(_templateObject);

var AppLayout = function (_Component) {
  (0, _inherits3.default)(AppLayout, _Component);

  function AppLayout() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AppLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppLayout.__proto__ || (0, _getPrototypeOf2.default)(AppLayout)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: _this.props.open }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AppLayout, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          HeaderComponent = _props.HeaderComponent,
          SidebarComponent = _props.SidebarComponent,
          children = _props.children,
          fixed = _props.fixed,
          sidebarWidth = _props.sidebarWidth,
          contentBackgroundColor = _props.contentBackgroundColor;
      var open = this.state.open;


      var toggleSidebar = function toggleSidebar() {
        _this2.setState(function (prevState) {
          return {
            open: !prevState.open
          };
        });
      };

      return _react2.default.createElement(
        AppLayoutOuterDiv,
        null,
        _react2.default.createElement(
          _StyledSidebar2.default,
          { sidebarWidth: sidebarWidth },
          _react2.default.createElement(
            _AppSidebar2.default,
            null,
            _react2.default.createElement(SidebarComponent, null)
          )
        ),
        _react2.default.createElement(
          _StyledMain2.default,
          { open: open, sidebarWidth: sidebarWidth, contentBackgroundColor: contentBackgroundColor },
          _react2.default.createElement(
            _AppHeader2.default,
            { open: open, sidebarWidth: sidebarWidth, toggleSidebar: toggleSidebar, fixed: fixed },
            _react2.default.createElement(HeaderComponent, null)
          ),
          _react2.default.createElement(
            _StyledContent2.default,
            { fixed: fixed },
            children
          )
        )
      );
    }
  }]);
  return AppLayout;
}(_react.Component);

AppLayout.propTypes = {
  children: _propTypes2.default.node.isRequired,
  HeaderComponent: _propTypes2.default.func,
  SidebarComponent: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  sidebarWidth: _propTypes2.default.string,
  fixed: _propTypes2.default.bool,
  contentBackgroundColor: _propTypes2.default.string
};
AppLayout.defaultProps = {
  open: false,
  HeaderComponent: function HeaderComponent() {
    return null;
  },
  SidebarComponent: function SidebarComponent() {
    return null;
  },
  sidebarWidth: '225px',
  fixed: false,
  contentBackgroundColor: '#F6F9FC'
};


AppLayout.displayName = 'hui:AppLayout';
AppLayout.huiName = 'AppLayout';

exports.default = AppLayout;
//# sourceMappingURL=AppLayout.js.map


//////////////////
// WEBPACK FOOTER
// ../app-layout/lib/AppLayout.js
// module id = 335
// module chunks = 0